<template>
  <div
    id="more-menu"
    class="dropdown dropdown-right"
    role="menu"
    aria-labelledby="display-menu-button"
    aria-haspopup="menu"
    aria-orientation="vertical"
    :aria-expanded="expanded.toString()"
  >
    <a
      @focus="expanded = true"
      @blur="expanded = false"
      href="#"
      id="display-menu-button"
      class="btn btn-link dropdown-toggle"
      tabindex="0"
      role="button"
      aria-label="Open menu"
      aria-haspopup="true"
      aria-controls="more-menu"
      :aria-expanded="expanded"
    >
      <more-vertical-icon v-bind:class="{ 'text-light': light }" />
    </a>
    <ul class="menu" role="none">
      <li class="menu-item" role="none">
        <router-link to="/import" class="text-dark" role="menuitem">
          <upload-icon size="1x" class="icon" />
          Import
        </router-link>
      </li>
      <li class="menu-item" role="none">
        <router-link to="/export" class="text-dark" role="menuitem">
          <download-icon size="1x" class="icon" />
          Export
        </router-link>
      </li>
      <li class="divider" role="none" aria-orientation="horizontal"></li>
      <li class="menu-item" role="none">
        <router-link to="/options" class="text-dark" role="menuitem">
          <settings-icon size="1x" class="icon" />
          Options
        </router-link>
      </li>
      <li class="divider" role="none" aria-orientation="horizontal"></li>
      <li v-if="manualPath" class="menu-item" role="none">
        <a :href="manualPath" class="text-dark" role="menuitem">
          <book-icon size="1x" class="icon" />
          User's Manual
        </a>
      </li>
      <li class="menu-item" role="none">
        <router-link to="/about" class="text-dark" role="menuitem">
          <info-icon size="1x" class="icon" />
          About
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import {
  MoreVerticalIcon,
  UploadIcon,
  DownloadIcon,
  SettingsIcon,
  BookIcon,
  InfoIcon
} from "vue-feather-icons";

import { HTMLPaths, PDFPaths } from "../paths";
import ConfigStore from "../stores/ConfigStore";

export default {
  name: "Menu",
  props: ["light"],
  data() {
    return { expanded: false };
  },
  computed: {
    manualPath() {
      switch (ConfigStore.methods.getManual()) {
        case "html":
          return HTMLPaths.manualPath;
        case "pdf":
          return PDFPaths.manualPath;
        default:
          return "";
      }
    }
  },
  components: {
    MoreVerticalIcon,
    UploadIcon,
    DownloadIcon,
    SettingsIcon,
    BookIcon,
    InfoIcon
  }
};
</script>
